var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2398 16.87C18.9798 17.13 18.5098 17.29 18.1498 17.33H2.59977C1.56977 17.22 0.599766 16.55 0.509766 15.45V2.51001C0.599766 1.38001 1.49977 0.34 2.65977 0.25H17.4998C18.6498 0.4 19.6198 1.34001 19.7598 2.51001V15.56C19.7098 16.02 19.5898 16.53 19.2498 16.87H19.2398ZM18.6598 11.99V2.40002C18.6598 2.12002 17.9698 1.45 17.6698 1.38L2.59977 1.34003C2.23977 1.33003 1.59977 2.04998 1.59977 2.34998V13.36L9.17977 8.09003L12.2798 11.4L15.0998 9.07001L18.6698 12L18.6598 11.99ZM18.4798 16.11C18.5598 16.02 18.6498 15.74 18.6598 15.61C18.7398 14.89 18.6198 13.99 18.6298 13.25L15.1198 10.34L12.1598 12.75L9.00977 9.34998L1.66977 14.45C1.54977 14.58 1.56977 15.2 1.58977 15.4C1.64977 15.92 2.11977 16.18 2.59977 16.24H18.2898C18.3498 16.19 18.4298 16.16 18.4798 16.12V16.11Z",
    fill: "#A797BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.489 3.19984C15.989 3.10984 16.179 6.8598 13.849 7.0998C11.009 7.3898 10.869 3.29984 13.489 3.19984ZM13.429 4.2898C12.039 4.5098 12.779 6.65981 14.029 5.91981C14.829 5.43981 14.379 4.1398 13.429 4.2898Z",
    fill: "#A797BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.2aeb5a7a986ad0b59afbe53a80096eef.svg";
export { ForwardRef as ReactComponent };